export const page = {
  seo: {
    title: 'Website for your restaurant or hospitality business | Bistroo',
    description: 'A personalised website for your restaurant, fully customisable to your wishes. Online in no time, 30 days free. Includes SEO optimisation and custom domain support.',
  },
  hero: {
    title: {
      pt1: 'A',
      pt2: 'website',
      pt3: 'fully tailored to your restaurant',
    },
    description:
      "Bistroo's website offers the tools to create a fully conversion-boosting landing page that improves your customers' ordering experience from start to finish.",
    button: 'Create your website',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Easy to build, effortless to maintain',
      text: "The website is generated based on your restaurant's information and easy to customize to perfectly match the style and branding of your restaurant.",
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Automatically updated',
      text: 'All changes you make in the Bistroo Manager are instantly reflected on your website, so you never have to manually update information across multiple editors or locations.',
      cta: '',
    },
    paragraph_3: {
      title: 'Deliver an excellent customer experience',
      text: 'From the first click to payment, your customers enjoy a well-designed ordering experience that contributes at every step — strengthening both the customer experience and the reputation of your restaurant.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Optimized for online use and e-commerce',
      text: "Our landing pages are designed and built for optimal SEO. Reach the top of organic search results in your area or give your website a boost with cost-efficient advertising.",
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Put your best sellers in the spotlight.',
        text: 'Your menu changes and top-selling items are seamlessly connected to your website — no extra work needed.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your favorite POS system or external tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Present and share key information.',
        text: 'Clearly communicate important information through your website by updating the settings in the Manager app.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Contact forms.',
        text: 'Accept requests through the integrated contact form.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Optimized for all channels.',
        text: 'All websites are optimized for Google Search and suitable for display on all types of devices.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo saves us a lot of time every day and significantly reduces customer frustration."',
    cta: 'Read the full story',
    name: 'Two-B by Mondie',
    job_title: 'Lunchroom',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo Website',
    items: [
      { q: 'What is the Bistroo restaurant website?', a: 'The Bistroo restaurant website is a personalised landing page for your hospitality business. Guests find your menu, opening hours, location and a direct order button — all in your own branding.' },
      { q: 'How do I create my Bistroo website?', a: 'The website is automatically generated based on the information in your Bistroo account. After signing up you choose a template, add your logo and colors and your site is ready to publish.' },
      { q: 'Can I use my own domain name?', a: 'Yes. You connect your own domain name to the Bistroo website so customers can find you via your own address, such as www.yourrestaurant.com.' },
      { q: 'Is my website optimized for Google?', a: 'Yes. All Bistroo websites are technically optimized for search engines. You rank better in local search results and on Google Maps, making it easier for new customers to find you.' },
      { q: 'Are menu changes automatically reflected on the website?', a: 'Yes. Changes you make in the Bistroo Manager are immediately reflected on your website. You never have to update information in multiple places at once.' },
      { q: 'Can I customize the style and look of my website?', a: 'Yes. You can adjust the colors, font, header image and layout via the Manager. This ensures the website perfectly matches the atmosphere of your restaurant.' },
      { q: 'Does the website display well on mobile?', a: 'Yes. All Bistroo websites are fully responsive and optimized for smartphones and tablets. Most visitors browse restaurants on their phone, so this is fully covered.' },
      { q: 'Can I add a contact form to my website?', a: 'Yes. Via the website settings in the Manager you activate a contact form where guests can submit enquiries, reservation requests or catering enquiries.' },
      { q: 'How do I promote offers and deals on my website?', a: 'Via the Manager you add banners, promotional text and discount codes that are immediately visible on your website. This way you always communicate your latest offers to your visitors.' },
      { q: 'What does the Bistroo restaurant website cost?', a: 'The basic page is included in every Bistroo package. A fully white-label website with a custom domain and advanced customization options is available on a paid package.' },
    ],
  },
}
